import { LogementPageBase, ViewKind } from "../LogementPageBase";

export const EditLogementPage = () => {
    return <LogementPageBase viewKind={ViewKind.Modify} />;
};
